import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Smartphone } from "lucide-react";
import { useTheme } from '@/contexts/ThemeContext';
import appStoreButtonsLight from '@/assets/app-store-buttons-light.png';
import phoneAppMockup from '@/assets/Phone_app_mock_up_Instagram_Post_45_5.svg';
import AnimatedBorderBadge from '@/components/editorial/AnimatedBorderBadge';

const YourStoryAppSection = () => {
  const { theme } = useTheme();
  const { ref: titleRef, isVisible: titleIsVisible } = useScrollAnimation();
  const { ref: imageRef, isVisible: imageIsVisible } = useScrollAnimation();

  const headingColor = theme === 'dark' ? '#FFFFFF' : '#111111';
  const textColor = theme === 'dark' ? '#AAAAAA' : 'rgba(0,0,0,0.8)';

  return (
    <section className="mt-0 sm:mt-0 -mb-24 sm:mb-0">
      <div className="flex flex-col pt-4 md:pt-8 lg:pt-12 pb-0">
        <div className="w-full max-w-5xl px-8 mx-auto pb-0">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:items-center w-full pb-0">
            <div ref={imageRef} className="flex justify-center lg:justify-start order-2 lg:ml-28 lg:mt-8 relative pb-0 z-0">
              <img 
                src={phoneAppMockup} 
                alt="Storily.io mobile app on phone screen" 
                width={320}
                height={400}
                className={`max-w-xs h-auto relative transition-all duration-500 ease-out hover:scale-110 hover:rotate-2 cursor-pointer ${imageIsVisible ? 'sm:opacity-100 sm:translate-y-0' : 'sm:opacity-0 sm:translate-y-12'}`} 
              />
            </div>
            <div className="flex items-center order-1 lg:ml-12" ref={titleRef}>
              <div className={`text-center lg:text-left w-full transition-all sm:duration-300 lg:duration-700 ${titleIsVisible ? 'sm:opacity-100' : 'sm:opacity-0'}`}>
                <AnimatedBorderBadge text="App" icon={Smartphone} align="left" />
                <h2 className="text-3xl lg:text-4xl font-bold mb-2" style={{ color: headingColor }}>The Storily App.</h2>
                <p className="text-xs sm:text-sm font-light leading-tight mt-2" style={{ color: textColor }}>
                  The All-In-One Marketing & Lead Management Platform. <br />In The Palm of Your Hand.<br /><br /><span className="font-bold">Available to Download. (Soon).</span>
                </p>
                <div className="mt-6 flex justify-center lg:justify-start">
                  {theme === 'dark' ? (
                    <div className="overflow-hidden" style={{ width: '140px' }}>
                      <img 
                        src={appStoreButtonsLight} 
                        alt="Download on App Store and Google Play" 
                        width={188}
                        height={64}
                        className="h-auto"
                        style={{ width: '188px', marginLeft: '-18px' }}
                      />
                    </div>
                  ) : (
                    <img 
                      src="/lovable-uploads/54776bb9-fe26-4cd3-b761-96c12fd6f59e.png" 
                      alt="Download on App Store and Google Play" 
                      width={96}
                      height={64}
                      className="max-w-24 h-auto" 
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YourStoryAppSection;
